// Static asset URLs (mirrored from /app/design_guidelines.json)
// Kept inside src/ so CRA bundles them without "outside of src" errors.

const u = {
  hero_aura_bg:
    "https://images.unsplash.com/photo-1585287794867-71d15fecdc5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGRhcmslMjBibHVlJTIwYXVyYSUyMGxpZ2h0fGVufDB8fHx8MTc3ODAxNjc5OXww&ixlib=rb-4.1.0&q=85",
  portfolio_mockup_1:
    "https://images.unsplash.com/photo-1619209629065-e9a2b225b24b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3NzgwMTY3OTl8MA&ixlib=rb-4.1.0&q=85",
  portfolio_mockup_2:
    "https://images.unsplash.com/photo-1639195276454-f0ec20b5bcb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3NzgwMTY3OTl8MA&ixlib=rb-4.1.0&q=85",
  portfolio_mockup_3:
    "https://images.unsplash.com/photo-1685018710168-1a38aae69890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsYXB0b3AlMjB3ZWJzaXRlJTIwbW9ja3VwJTIwZGFya3xlbnwwfHx8fDE3NzgwMTY3OTl8MA&ixlib=rb-4.1.0&q=85",
  testimonial_avatar_1:
    "https://images.unsplash.com/photo-1758599543136-5977bf2dd922?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBmYWNlfGVufDB8fHx8MTc3ODAxNjc4MHww&ixlib=rb-4.1.0&q=85",
  testimonial_avatar_2:
    "https://images.unsplash.com/photo-1758518729459-235dcaadc611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBmYWNlfGVufDB8fHx8MTc3ODAxNjc4MHww&ixlib=rb-4.1.0&q=85",
  testimonial_avatar_3:
    "https://images.unsplash.com/photo-1651684215020-f7a5b6610f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBmYWNlfGVufDB8fHx8MTc3ODAxNjc4MHww&ixlib=rb-4.1.0&q=85",
  about_us_office:
    "https://images.unsplash.com/photo-1561382781-76dd6a2ce0b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2UlMjBkYXJrfGVufDB8fHx8MTc3ODAxNjc5OXww&ixlib=rb-4.1.0&q=85",
};

const design = {
  image_urls: Object.fromEntries(
    Object.entries(u).map(([k, url]) => [k, { url }])
  ),
};

export default design;
export const images = u;
